import {makeStyles} from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
    pageWrapper: {
        width: "100%",
        height: "100%",
        position: "relative",
        overflow: "hidden",
    },
    container: {
        padding: "1em",
        width: "100%",
        height: "100%",
        overflow: "hidden",
    }
}));